import React, { createContext } from 'react'
import { useQuery } from 'react-query'

import { fetchAuthorizedRoutes, fetchCurrentUserInfo } from 'services/user'
import { Route, UserInfo } from 'types/domain'

interface UserContextValue {
  authorizedRoutes?: Route[]
  userInfo?: UserInfo
  error?: unknown
  loading: boolean
}

const UserContext = createContext<UserContextValue>({
  loading: false,
})
const { Provider } = UserContext

export const UserContextProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const userInfoResult = useQuery<UserInfo>('userinfo', fetchCurrentUserInfo)
  const authorizedRoutesResult = useQuery<Route[]>(
    'authorizedRoutes',
    fetchAuthorizedRoutes,
  )

  return (
    <Provider
      value={{
        userInfo: userInfoResult.data,
        authorizedRoutes: authorizedRoutesResult.data || [],
        error: userInfoResult.error || authorizedRoutesResult.error,
        loading: userInfoResult.isLoading || authorizedRoutesResult.isLoading,
      }}
    >
      {children}
    </Provider>
  )
}

export default UserContext
